<div class="print-page" [attr.dir]="dir">
  <ng-container *ngIf="loaded && referral">

    <div class="rf-header">
      <div [innerHtml]="altHeader" *ngIf="altHeader"></div>
      <div *ngIf="!altHeader && env && env['haslogo']" style="margin-bottom: 0.8em;">
        <img src="/api/logo" alt="Logo" style="max-height: 80px; max-width: 100%;" />
      </div>
      <h1 class="rf-title">{{ lbl.title }}</h1>
    </div>

    <div class="rf-print-date">
      <span *ngIf="referral.CreatedAt">{{ lang === 'he' ? 'תאריך יצירה' : 'Created' }}: {{ formatDate(referral.CreatedAt) }}</span>
      <span *ngIf="referral.CreatedAt" class="rf-date-sep">|</span>
      <span>{{ lang === 'he' ? 'תאריך הדפסה' : 'Print Date' }}: {{ printDate }}</span>
    </div>

    <div class="rf-patient">
      <div class="rf-field">
        <span class="rf-label">{{ lbl.name }}:</span>
        <span class="rf-value">{{ referral.PatLast }} {{ referral.PatFirst }}</span>
      </div>
      <div class="rf-field" *ngIf="referral.PatIDNum">
        <span class="rf-label">{{ lbl.id }}:</span>
        <span class="rf-value">{{ referral.PatIDNum }}</span>
      </div>
      <div class="rf-field" *ngIf="referral.PatDOB">
        <span class="rf-label">{{ lbl.dob }}:</span>
        <span class="rf-value">{{ formatDate(referral.PatDOB) }}</span>
      </div>
      <div class="rf-field" *ngIf="referral.HMO">
        <span class="rf-label">{{ lbl.hmo }}:</span>
        <span class="rf-value">{{ getHMO(referral.HMO) }}</span>
      </div>
    </div>

    <div class="rf-groups">
      <div class="rf-group" *ngFor="let g of groups">
        <div class="rf-group-title">{{ g.name }}</div>
        <ul class="rf-tests">
          <li class="rf-test" *ngFor="let t of g.tests">
            <span class="rf-test-name">{{ t.name }}</span>
            <span class="rf-test-code" *ngIf="t.code">{{ t.code }}</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="rf-footer">
      <div class="rf-instructions" *ngIf="referral.Instructions">
        <span class="rf-label">{{ lbl.instructions }}:</span>
        <p class="rf-instructions-text">{{ referral.Instructions }}</p>
      </div>

      <div class="rf-footer-row" *ngIf="referral.SignedAt">
        <div class="rf-signed" *ngIf="referral.Opener">
          <div>
            <span class="rf-label">{{ lbl.signedBy }}:</span>
            <span class="rf-value">{{ getSignerDisplay(referral) }}</span>
          </div>
          <img *ngIf="doctorSignatureUrl" [src]="doctorSignatureUrl" class="rf-signature-img" alt="Signature">
        </div>
        <div class="rf-signed" *ngIf="referral.OpenerDrNum">
          <span class="rf-label">{{ lbl.licenseNum }}:</span>
          <span class="rf-value">{{ referral.OpenerDrNum }}</span>
        </div>
        <div class="rf-signed" *ngIf="referral.OpenerExpertNum">
          <span class="rf-label">{{ lbl.expertNum }}:</span>
          <span class="rf-value">{{ referral.OpenerExpertNum }}</span>
        </div>
      </div>
    </div>

  </ng-container>

  <div *ngIf="!loaded" class="rf-loading">...</div>
</div>
